import { createBrowserRouter, Navigate } from "react-router-dom"
import Body from "../components/body"
import Nav from "../components/nav"
import Footer from "../components/footer"
import LoginPage from "./login"
import ForgotPasswordPage from "./forgot-password"
import RegisterPage from "./register"
import Landing from "./landing"
import "../index.css"
import Dashboard from "./protected/DashboardContainer"
import ProtectedRoute from "../components/ProtectedRoute"
import WordsCreatedContainer from "./protected/WordsCreatedContainer"
import WordsSentContainer from "./protected/WordsSentContainer"
import CreateTextContainer from "./protected/CreateTextContainer"
import ListTextContainer from "./protected/ListTextContainer"
import Terms from "./terms"
import BodyAlt from "../components/body-alt"
import DownloadsContainer from "./protected/DownloadsContainer"
import InferenceLearningContainer from "./protected/InferenceLearningContainer"

import InferenceList from './protected/inference/InferenceList';
import InferenceView from './protected/inference/InferenceView';
import Subscription from './protected/Subscription';
import LocalPayment from './protected/LocalPayment';
import AdminPayments from './protected/AdminPayments';
import AdminSchools from './protected/AdminSchools';
import AdminLeads from './protected/AdminLeads';
import AdminEvents from './protected/AdminEvents';
import SchoolPanel from './protected/SchoolPanel';
import SchoolRepresentatives from './protected/SchoolRepresentatives';
import TeacherPanel from './protected/TeacherPanel';
import RepresentativePanel from './protected/RepresentativePanel';
import ClassActivity from './protected/ClassActivity';
import Onboarding from './protected/Onboarding';
import UserGuide from './protected/UserGuide';

// Monetización oculta hasta estar listos (Stripe live). Se activa con REACT_APP_MONETIZATION_ENABLED=true.
const MONETIZATION_ENABLED = process.env.REACT_APP_MONETIZATION_ENABLED === "true"

export const router = createBrowserRouter([
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/login",
    element: (
      <>
        <Nav />
        <Body>
          <LoginPage />
        </Body>
        <Footer />
      </>
    ),
  },
  {
    path: "/register/:step",
    element: (
      <>
        <Nav />
        <Body>
          <RegisterPage />
        </Body>
        <Footer />
      </>
    ),
  },
  {
    path: "/privacy",
    element: (
      <>
        <Nav />
        <BodyAlt>
          <Terms />
          <Footer isTerms={true} />
        </BodyAlt>
      </>
    ),
  },
  {
    path: "/forgot-password",
    element: (
      <>
        <Nav />
        <Body>
          <ForgotPasswordPage />
        </Body>
        <Footer />
      </>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <>
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/onboarding",
    element: (
      <>
        <ProtectedRoute>
          <Onboarding />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/words/created",
    element: (
      <>
        <ProtectedRoute>
          <WordsCreatedContainer />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/words/received",
    element: (
      <>
        <ProtectedRoute>
          <WordsCreatedContainer isModule={"received"} />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/words/sent",
    element: (
      <>
        <ProtectedRoute>
          <WordsSentContainer isModule={"sent"} />
        </ProtectedRoute>
      </>
    ),
  },
  /* {
		path: '/words/edited',
		element: (
			<>
				<ProtectedRoute>
					<WordsCreatedContainer isEdited={true}/>
				</ProtectedRoute>
			</>
		)
	}, */
  {
    path: "/family/created",
    element: (
      <>
        <ProtectedRoute>
          <WordsCreatedContainer isModule={"family"} />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/actions/create-text",
    element: (
      <>
        <ProtectedRoute>
          <CreateTextContainer />
        </ProtectedRoute>
      </>
    ),
  },
  {
    // Pública: accesible desde la landing (footer) y desde el portal.
    // UserGuide se adapta: con sesión muestra el chrome de la app; sin sesión, barra mínima.
    path: "/user-guide",
    element: <UserGuide />,
  },
  {
    path: "/actions/list-texts",
    element: (
      <>
        <ProtectedRoute>
          <ListTextContainer />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/actions/downloads",
    element: (
      <>
        <ProtectedRoute>
          <DownloadsContainer />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/inference",
    element: (
      <>
        <ProtectedRoute>
          <InferenceList />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/subscription",
    element: (
      <>
        <ProtectedRoute>
          {MONETIZATION_ENABLED ? <Subscription /> : <Navigate to="/dashboard" replace />}
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/subscription/local",
    element: (
      <>
        <ProtectedRoute>
          {MONETIZATION_ENABLED ? <LocalPayment /> : <Navigate to="/dashboard" replace />}
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/admin/payments",
    element: (
      <>
        <ProtectedRoute>
          <AdminPayments />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/admin/schools",
    element: (
      <>
        <ProtectedRoute>
          <AdminSchools />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/admin/leads",
    element: (
      <>
        <ProtectedRoute>
          <AdminLeads />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/admin/events",
    element: (
      <>
        <ProtectedRoute>
          <AdminEvents />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/school",
    element: <Navigate to="/school/teachers" replace />,
  },
  {
    path: "/school/teachers",
    element: (
      <>
        <ProtectedRoute>
          <SchoolPanel view="teachers" />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/school/grades",
    element: (
      <>
        <ProtectedRoute>
          <SchoolPanel view="grades" />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/school/sections",
    element: (
      <>
        <ProtectedRoute>
          <SchoolPanel view="sections" />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/school/students",
    element: (
      <>
        <ProtectedRoute>
          <SchoolPanel view="students" />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/school/representatives",
    element: (
      <>
        <ProtectedRoute>
          <SchoolRepresentatives />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/teacher",
    element: (
      <>
        <ProtectedRoute>
          <TeacherPanel />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/activity",
    element: (
      <>
        <ProtectedRoute>
          <ClassActivity />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/representative",
    element: (
      <>
        <ProtectedRoute>
          <RepresentativePanel />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/inference/create",
    element: (
      <>
        <ProtectedRoute>
          <InferenceLearningContainer />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/inference/view",
    element: (
      <>
        <ProtectedRoute>
          <InferenceView />
        </ProtectedRoute>
      </>
    ),
  },
  {
    path: "/actions/texts/edit/:id",
    element: (
      <>
        <ProtectedRoute>
          <CreateTextContainer isEdit={true} />
        </ProtectedRoute>
      </>
    ),
  },
])
